var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"counterparties-tabs"},[_c('div',{staticClass:"counterparties-tabs_top"},_vm._l((_vm.links),function(link){return _c('router-link',{key:link.to,ref:"tab",refInFor:true,staticClass:"counterparties-tabs_link",attrs:{"to":link.to}},[_vm._v(_vm._s(link.text))])}),1),_c('router-view',{attrs:{"client":_vm.client}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }